module.exports = __webpack_public_path__ + "img/add-product.45a8983d.svg";